/**
 * Transient UI-only keys on trade-in state objects.
 * These are used by the UI but must never be included in save payloads,
 * otherwise the "Unsaved Changes" comparison will detect false differences.
 */
const UI_ONLY_KEYS: ReadonlySet<string> = new Set([
    'openManualForm',
    'vinHasBeenDecoded',
    'isTradeBeingSaved',
    'errorDecodingVin',
    'hasBeenSaved',
    'hasMultipleVin',
    'multipleVinOptions',
    'trimDecodedOptions'
]);

/**
 * Returns a shallow copy of the trade-in object with all UI-only keys removed.
 * When `enabled` is false the original object is returned unchanged.
 */
export const stripUIFields = (obj: Record<string, any>, enabled = true): Record<string, any> =>
    enabled ? Object.fromEntries(Object.entries(obj).filter(([key]) => !UI_ONLY_KEYS.has(key))) : obj;
